import React, {useEffect, useState} from "react";
import {Alert, Card, Col, Container, InputGroup, Row} from "react-bootstrap";
import Form from "react-bootstrap/Form";
import * as formik from "formik";
import * as yup from "yup";
import Button from "react-bootstrap/Button";
import {observer} from "mobx-react";
import {authApi} from "../../api/auth.js";
import {useParams} from "react-router-dom";
import bctcLogo from "../../images/BCTC_Logo_Horiz_small.png";
function ResetPasswordPage() {
    const {Formik} = formik;
    const {resetKey} = useParams();
    const [resetSuccessful, setResetSucessful] = useState(false);
    const [resetKeyValid, setResetKeyValid] = useState(true);
    const schema = yup.object().shape({
        password: yup.string()
            .required("Password is required")
            .matches(
                /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/,
                "Password must be at least 8 characters, with an uppercase letter, lowercase letter, and a number."
            ),
        passwordConfirm: yup.string()
            .required("Password Confirm is required")
            .oneOf([yup.ref('password')], 'Passwords must match'),
    });

    useEffect(() => {
        const validateKey = async (key) => {
            const result = await authApi.validateResetKey(key);
            setResetKeyValid(result.validPasswordKey);
        }
        if (resetKey) {
            validateKey(resetKey);
        } else {
            setResetKeyValid(false);
        }

    }, [resetKey]);

    if (!resetKeyValid) {
        return (
        <div className="auth-shell">
            <Container style={{maxWidth: 680}}>
                <Card className="auth-card p-4 mx-auto">
                    <div className="auth-header">
                        <img src={bctcLogo} height="64" alt="BCTC logo" />
                        <h1 className="auth-title">Reset Password</h1>
                        <p className="auth-subtitle">The reset link is invalid or expired.</p>
                    </div>
                    <Alert variant={"danger"} className="mt-2">
                        The password reset link is invalid or expired. Please request a new link from the login page.
                    </Alert>
                    <div className="d-grid mt-3">
                        <Button variant="primary" href="/login">Go to Login</Button>
                    </div>
                </Card>
            </Container>
        </div>
        );

    } else if (resetSuccessful){
        return (
            <div className="auth-shell">
                <Container style={{maxWidth: 680}}>
                    <Card className="auth-card p-4 mx-auto">
                        <div className="auth-header">
                            <img src={bctcLogo} height="64" alt="BCTC logo" />
                            <h1 className="auth-title">Password reset</h1>
                            <p className="auth-subtitle">Your password has been updated.</p>
                        </div>
                        <p className="mb-3">You may now use your new password to sign in.</p>
                        <div className="d-grid">
                            <Button href="/login">Go to Login</Button>
                        </div>
                    </Card>
                </Container>
            </div>

        );
    } else {
        return (
            <div className="auth-shell">
                <Container style={{maxWidth: 680}}>
                    <Card className="auth-card p-4 mx-auto">
                        <div className="auth-header">
                            <img src={bctcLogo} height="64" alt="BCTC logo" />
                            <h1 className="auth-title">Reset Password</h1>
                            <p className="auth-subtitle">Enter your new password below.</p>
                        </div>
                        <Formik
                            validationSchema={schema}
                            onSubmit={async (values, { setSubmitting }) => {
                                try {
                                    setSubmitting(true);
                                    await authApi.resetPassword(values.password, resetKey);
                                    setResetSucessful(true);
                                } finally {
                                    setSubmitting(false);
                                }

                            }}
                            initialValues={{
                                password: "",
                                passwordConfirm: "",
                            }}
                        >
                            {({ handleSubmit, handleChange, touched, values, isSubmitting, errors }) => (
                                <Form noValidate onSubmit={handleSubmit}>
                                    <Row className="mb-3">
                                        <Form.Group as={Col} md="6" controlId="password">
                                            <Form.Label>Password</Form.Label>
                                            <InputGroup hasValidation>
                                                <Form.Control
                                                    type="password"
                                                    name="password"
                                                    value={values.password}
                                                    onChange={handleChange}
                                                    isInvalid={touched.password && !!errors.password}
                                                />
                                                {touched.password && (<Form.Control.Feedback type="invalid">
                                                    {errors.password}
                                                </Form.Control.Feedback>)}
                                            </InputGroup>
                                        </Form.Group>
                                        <Form.Group as={Col} md="6" controlId="passwordConfirm">
                                            <Form.Label>Confirm Password</Form.Label>
                                            <InputGroup hasValidation>
                                                <Form.Control
                                                    type="password"
                                                    name="passwordConfirm"
                                                    value={values.passwordConfirm}
                                                    onChange={handleChange}
                                                    isInvalid={touched.passwordConfirm && !!errors.passwordConfirm}
                                                />
                                                {touched.passwordConfirm && (<Form.Control.Feedback type="invalid">
                                                    {errors.passwordConfirm}
                                                </Form.Control.Feedback>)}
                                            </InputGroup>
                                        </Form.Group>
                                    </Row>

                                    <div className="d-grid gap-2">
                                        <Button type="submit" disabled={isSubmitting}>Reset My Password</Button>
                                    </div>
                                </Form>
                            )}
                        </Formik>
                    </Card>
                </Container>
            </div>

        );
    }

}


export default observer(ResetPasswordPage);
